module.exports = __webpack_public_path__ + "static/media/ri.69816e9b.png";